import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertService } from "../../../../shared/alert/alert.service";
import { TrialService } from "../../../../core/services/trial.service";
import { TrialMailbox } from "../../../../core/models/trial-mailbox.model";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ModalComponent } from "../../../../shared/modal/modal.component";

@Component({
  selector: 'app-trial-mailbox',
  templateUrl: './trial-mailbox.component.html',
  styleUrls: ['./trial-mailbox.component.scss']
})
export class TrialMailboxComponent implements OnInit, AfterViewInit {
  @ViewChild('removeMailboxModal') removeMailboxModal: ModalComponent;
  @ViewChild('addMailboxModal') addMailboxModal: ModalComponent;

  @Input('trialId') trialId: string;

  mailboxes: TrialMailbox[] = [];

  form: UntypedFormGroup;
  deletingMailbox: TrialMailbox;
  deleteInProgress = false;

  constructor(private _alertService: AlertService, private _trialService: TrialService) {
    this.form = new UntypedFormGroup({
      processing: new UntypedFormControl(false),
      email: new UntypedFormControl('', [Validators.required, Validators.email])
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.loadMailboxes();
  }

  loadMailboxes(): void {
    this._trialService.getMailboxes(this.trialId).subscribe({
      next: (mailboxes) => {
        this.mailboxes = mailboxes;
      },
      error: error => {
        this._alertService.showErrorAlert(error);
      }
    });
  }

  onShowAddMailbox(): void {
    this.form.reset();

    this.addMailboxModal.show();
  }

  onRemoveMailbox(mailbox: TrialMailbox) {
    this.deletingMailbox = mailbox;

    this.removeMailboxModal.show();
  }

  onConfirmRemoveMailbox(): void {
    this.deleteInProgress = true;
    this._trialService.removeMailbox(this.trialId, this.deletingMailbox.id).subscribe({
      next: () => {
        this.deleteInProgress = false;
        this.loadMailboxes();
        this.deletingMailbox = null;
        this.removeMailboxModal.hide();
      },
      error: error => {
        this.deleteInProgress = false;
        this._alertService.showErrorAlert(error);
      }
    });
  }

  onAddMailbox(): void {
    let form = this.form;

    if (form.valid) {
      let exists = false;
      this.mailboxes.forEach(mailbox => {
        if (mailbox.email === form.value.email) {
          exists = true;
          this._alertService.showWarningAlert("This mailbox already exists on the trial");
        }
      });

      if (!exists) {
        this.form.patchValue({processing: true});
        this._trialService.addMailbox(this.trialId, form.value.email).subscribe({
          next: () => {
            this.form.patchValue({processing: false});
            this._alertService.showSuccessAlert('Mailbox added successfully');
            this.addMailboxModal.hide();
            this.loadMailboxes();
          },
          error: error => {
            this.form.patchValue({processing: false});
            this._alertService.showErrorAlert(error);
          }
        });
      }

    }
  }

}
